import { Radio } from "antd";
import { Uniter } from "../../../helbest";
import styles from "./Payment.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { toFixedNumber } from "../../../base/utils";
import { ReactComponent as ArrowRight } from "../../../assets/svg/wide-right-arrow.svg";
import { ReactComponent as CashIcon } from "../../../assets/svg/cash-icon.svg";
import { useEffect } from "react";

export const COD_VALUE = "COD";

const PaymentOptions = ({ value, setValue, payable }) => {
  const { paymentOptions: paymentData } = useSelector((state) => state.Login);
  const { t } = useTranslation();

  const rawData = paymentData?.[0]?.data;
  const gateways = Array.isArray(rawData) ? rawData : [];
  const hasGateways = gateways.length > 0;

  const onChange = (e) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    // Only auto-select when nothing is chosen yet, so this doesn't clobber
    // a user's COD selection (or any other pick) if paymentData re-renders
    // with a new array reference.
    if (hasGateways && !value) setValue(gateways[0]?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);

  const qpayData = gateways.find((payment) => payment.id === "QPAY");

  // Note: the old "no_payment_option" early-return is gone — COD is always
  // rendered, so there's no longer a state with zero selectable options.

  return (
    <div className="mt-2">
      <div className={styles.BoxTitle}>{t("cart.payment_option")}</div>

      {!!qpayData && (
        <div
          className={`${styles.qpayCard} ${Number(payable) === 0 ? styles.qpayDisabled : ""
            }`}
          onClick={() => {
            if (Number(payable) === 0) return;
            setValue(qpayData.id);
          }}
        >
          <div className={styles.logoWrapper}>
            <img
              alt="paymentIcons"
              src={qpayData.logo}
              width={36}
              height={36}
            />
          </div>
          <div className={styles.content}>
            <div className={styles.header}>QPay - {t("cart.qpay_title")}</div>
            <div className={styles.pricing}>
              <Uniter className={styles.uniter} isBold>
                {toFixedNumber(Number(payable) / 4)}
              </Uniter>
              / {t("cart.qpay_months")}
            </div>
            <div className={styles.subtext}>{t("cart.qpay_desc")}</div>
          </div>
          <ArrowRight className={styles.arrowWrapper} />
        </div>
      )}

      <Radio.Group
        onChange={onChange}
        value={value}
        disabled={Number(payable) === 0}
        className={styles.paymentRadio}
      >
        {gateways.map((payment) => {
          if (payment.id === "WALLET" || payment.id === "QPAY") return null;
          return (
            <Radio value={payment?.id} defaultChecked key={payment.id}>
              <div
                className={`flex items-center gap-4 ${styles.ItemContainer}`}
              >
                <img
                  alt="paymentIcons"
                  src={payment.logo}
                  width={36}
                  height={36}
                />
                <div>
                  <span>{payment.name}</span>
                  {payment.fee_percentage > 0 ? (
                    <p className={styles.feePercent}>
                      {t("cart.addition", {
                        amount: payment.fee_percentage,
                      })}
                    </p>
                  ) : null}
                </div>
              </div>
            </Radio>
          );
        })}

        <Radio value={COD_VALUE} key={COD_VALUE}>
          <div className={`flex items-center gap-4 ${styles.ItemContainer}`}>
            <CashIcon width={36} height={36} />
            <div>
              <span>{t("cart.cash_on_delivery")}</span>
              <p className={styles.feePercent}>{t("cart.cash_on_delivery_desc")}</p>
            </div>
          </div>
        </Radio>
      </Radio.Group>
    </div>
  );
};

export default PaymentOptions;